import * as React from 'react'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import { Button, TextField } from '@mui/material'
import styled from '@emotion/styled'
import { Cached, Search } from '@mui/icons-material'
import { RegulationAccordion } from './RegulationAccordion'

export interface TabPanelProps {
  children?: React.ReactNode
  index: number
  value: number
}

const StyledButton = styled(Button)({
  display: 'inline-flex',
  justifyContent: 'center',
  alignItems: 'center',
  cursor: 'pointer',
  borderRadius: '4px',
  minWidth: '48px',
  height: '48px',
  padding: '14px',
  textDecoration: 'none',
  transition: 'all 0.4s ease 0s',
  '& svg': {
    color: '#fff',
    fontSize: '20px',
  },
})

export function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  )
}

export function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
    sx: {
      fontSize: '16px',
      fontWeight: 400,
      alignItems: 'flex-start',
    },
  }
}

interface Props {
  items: {
    id: number
    title: string
    value: string
  }[]
}

export const CustomTabs: React.FC<Props> = ({ items }) => {
  const [value, setValue] = React.useState(0)

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue)
  }

  return (
    <Box>
      <Box sx={{ borderBottom: 0.5, borderColor: 'divider', width: 'max-content' }}>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
          {items?.map((item) => {
            return <Tab key={item.id} label={item.title} {...a11yProps(item.id)} />
          })}
        </Tabs>
      </Box>
      <Box display="flex" sx={{ margin: '24px 0' }}>
        <TextField
          InputLabelProps={{ shrink: false }}
          id="search"
          placeholder="Tez-tez verilən suallar üzrə axtarış"
          variant="outlined"
          fullWidth
          sx={{
            maxHeight: '48px',
            '& .MuiInputBase-input': {
              borderTopRightRadius: '0 !important',
              borderBottomRightRadius: '0 !important',
            },
            '& fieldset': {
              borderTopRightRadius: '0 !important',
              borderBottomRightRadius: '0 !important',
            },
          }}
        />
        <Box display="flex" gap="10px">
          <StyledButton
            sx={{
              background: 'rgb(122, 127, 126)',
              borderTopLeftRadius: '0 !important',
              borderBottomLeftRadius: '0 !important',
              '&:hover': {
                background: 'rgb(135, 141, 140)',
              },
            }}
          >
            <Search />
          </StyledButton>
          <StyledButton
            sx={{
              background: 'rgb(3, 34, 76)',
              color: '#fff',
              '&:hover': {
                background: 'rgba(3, 34, 76, 0.6)',
              },
            }}
          >
            <Cached />
          </StyledButton>
        </Box>
      </Box>

      <CustomTabPanel value={value} index={0}>
        <RegulationAccordion
          title="İddiaçının ixtisas göstəricilərinin yoxlanılması üçün hansı tələblər qoyula bilər?"
          content="Satınalma prosedurlarında iştirak etmək üçün malgöndərənlərin (podratçıların) ixtisas göstəriciləri “Dövlət satınalmaları haqqında” Azərbaycan Respublikası Qanununun (bundan sonra “DSQ”) 6.2-ci bəndində göstərilən meyarlara uyğun gəlməlidir. Satınalan təşkilat bu maddədə nəzərdə tutulmayan, həmçinin ayrıseçkilik salan hər hansı digər meyarlar, tələblər və ya prosedurlar müəyyənləşdirə bilməz [DSQ 6.2 və 6.3]."
        />
        <RegulationAccordion
          title="Tenderə təqdim edilən sənədlərin notarial qaydada təsdiq olunması vacibdirmi?"
          content="Satınalan təşkilat satınalma prosedurları zamanı iddiaçının ixtisas göstəricilərini əks etdirən sənədlərin Azərbaycan Respublikasının qanunvericiliyində nəzərdə tutulmuş qaydada təsdiq olunmasını və rəsmiləşdirilməsini tələb edə bilər [DSQ 6.9]."
        />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <RegulationAccordion
          title="Funksional İddiaçının ixtisas göstəricilərinin yoxlanılması üçün hansı tələblər qoyula bilər?"
          content="Satınalma prosedurlarında iştirak etmək üçün malgöndərənlərin (podratçıların) ixtisas göstəriciləri “Dövlət satınalmaları haqqında” Azərbaycan Respublikası Qanununun (bundan sonra “DSQ”) 6.2-ci bəndində göstərilən meyarlara uyğun gəlməlidir. Satınalan təşkilat bu maddədə nəzərdə tutulmayan, həmçinin ayrıseçkilik salan hər hansı digər meyarlar, tələblər və ya prosedurlar müəyyənləşdirə bilməz [DSQ 6.2 və 6.3]."
        />
        <RegulationAccordion
          title="Tenderə təqdim edilən sənədlərin notarial qaydada təsdiq olunması vacibdirmi?"
          content="Satınalan təşkilat satınalma prosedurları zamanı iddiaçının ixtisas göstəricilərini əks etdirən sənədlərin Azərbaycan Respublikasının qanunvericiliyində nəzərdə tutulmuş qaydada təsdiq olunmasını və rəsmiləşdirilməsini tələb edə bilər [DSQ 6.9]."
        />
      </CustomTabPanel>
    </Box>
  )
}
